import React, { useEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormLabel from '@material-ui/core/FormLabel';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useStyles from './styles';
import WagonNumberAutocomplete from '../WagonNumberAutocomplete/WagonNumberAutocomplete';
import ApiService from '../../services/ApiService';
import { setTicketNumber } from '../HomePage/ContentTabs/ContentTabsSlice';
import {
  setEditedTicket,
  setValidationErrorsMultiLang,
  setTicketExistButNotVisible,
} from '../EditTicket/EditTicketSlice';
import i18n from '../../i18n';
import { userInfoState } from '../HomePage/HomeSlice';

function AddTicketPopUp(props) {
  const { open } = props;
  const [wagonNumber, setWagonNumber] = React.useState('');
  const [errorPresent, setErrorPresent] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);

  const [errorMessageInSelectedLang, setErrorMessageInSelectedLang] =
    React.useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();
  const mountedRef = useRef(true);
  const { t } = useTranslation();
  const lang = i18n.language;
  const history = useHistory();
  const user = useSelector(userInfoState);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (errorMessage) {
      if (lang === 'en') {
        setErrorMessageInSelectedLang(errorMessage.messageEN);
      } else if (lang === 'fr') {
        setErrorMessageInSelectedLang(errorMessage.messageFR);
      } else if (lang === 'de') {
        setErrorMessageInSelectedLang(errorMessage.messageDE);
      } else {
        setErrorMessageInSelectedLang(errorMessage.messageEN);
      }
    }
  }, [lang, errorMessage]);

  function getErrorPresent(error) {
    setErrorPresent(error);
  }

  function getErrorMessage(error) {
    setErrorMessage(error);
    if (error == null) {
      setErrorMessageInSelectedLang(null);
    }
  }

  function getWagonNumber(selectedWagonNumber) {
    setWagonNumber(selectedWagonNumber);
  }

  const handleClose = () => {
    props.setPopUpOpenedState(false);
    if (mountedRef.current) {
      setWagonNumber('');
      setErrorMessage(null);
      setErrorPresent(false);
    }
  };

  const retrieveTicketInfos = (response) => {
    if (response.status) {
      if (user.internal || user.hasEmilyDRights || user.externalMax) {
        dispatch(setTicketNumber(response.data.ticket.ticketNumber));
        dispatch(setEditedTicket(response.data.ticket));
        dispatch(setValidationErrorsMultiLang(response.data.validationErrors));
        history.push(`/ticket/details/${response.data.ticket.ticketNumber}`);
      } else if (response.data && response.data.anomalies.length > 0) {
        dispatch(setTicketNumber(response.data.ticketNumber));
        dispatch(setEditedTicket(response.data));
        dispatch(setValidationErrorsMultiLang(response.data.validationErrors));
        history.push(`/ticket/details/${response.data.ticketNumber}`);
      } else {
        dispatch(setEditedTicket(response.data));
        dispatch(setValidationErrorsMultiLang({}));
        props.setAddTicketState(true);
        dispatch(setTicketExistButNotVisible(true));
        history.push(`/ticket/creation`);
      }

      props.setAddTicketState(false);
    } else {
      dispatch(setEditedTicket(response));
      dispatch(setValidationErrorsMultiLang({}));
      props.setAddTicketState(true);
      history.push(`/ticket/creation`);
    }
    handleClose();
  };

  function handleValidate() {
    if (mountedRef.current) {
      ApiService.getTicketByWagonNumber(wagonNumber)
        .then((response) => {
          retrieveTicketInfos(response);
        })
        .catch((error) => {
          if (error) {
            setErrorMessage(error);
          }
          setErrorPresent(true);
        });
    }
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent className={classes.dialog}>
        <DialogContentText className={classes.dialogText}>
          {t('add ticket popup description')}
        </DialogContentText>
        <FormLabel className={classes.title}>{t('Wagon number')} </FormLabel>{' '}
        <WagonNumberAutocomplete
          wagonNumber={wagonNumber}
          errorPresent={errorPresent}
          errorMessage={errorMessageInSelectedLang}
          setErrorPresent={getErrorPresent}
          setErrorMessage={getErrorMessage}
          setWagonNumber={getWagonNumber}
        />
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.validateButton}
          variant="contained"
          autoFocus
          onClick={handleValidate}
          color="secondary"
          disabled={wagonNumber === ''}
        >
          {t('Validate')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default AddTicketPopUp;
